exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.retenue-garantie[data-v-b60401ce] {\n  /*font-style: italic;*/\n  /*color: #409eff;*/\n}\n.trop-percu[data-v-b60401ce] {\n  color: red;\n}\n", ""]);

// exports
